import { useContext } from "react"
import { useAppSelector } from "../reducers/hooks"
import { XmppContext } from "../stream/xmppClient"
import {
  hasMessageFileBeenShared,
  selectActiveChat,
  selectMessageChat,
} from "../reducers/chatsSliceSelectors"
import { Message } from "../reducers/messagesSlice"
import { selectChatMessages } from "../reducers/messagesSliceSelectors"

export default function useHasFileBeenShared(message: Message | undefined) {
  const activeChat = useAppSelector(selectActiveChat)
  const { myJid } = useContext(XmppContext)
  const originalChat = useAppSelector(
    selectMessageChat(message as Message, myJid.toString()),
  )
  const originalChatMessages = useAppSelector(
    selectChatMessages(originalChat?.jid),
  )
  const chatMessages = useAppSelector(selectChatMessages(activeChat?.jid))
  if (!message) return false
  return Boolean(
    (chatMessages && hasMessageFileBeenShared(chatMessages, message.id)) ||
      (originalChatMessages &&
        hasMessageFileBeenShared(originalChatMessages, message.id)),
  )
}
